import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Snackbar,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  TextField,
  Typography
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { auth } from "../../../firebase";
import {
  AttachFile,
  Close,
  CloudUpload,
  PictureAsPdf,
  UploadFile
} from "@mui/icons-material";
import ReusableModal from "../Model";
import ReactMarkdown from "react-markdown";

const UserView = () => {

  const [val, setVal] = React.useState({
    temperature: 25,
    humidity: 50,
    nitrogen: 50,
    potassium: 50,
    phosphorus: 50,
    moisture: 20,
    croptype: "Barley",
    soiltype: "Black",
    modeltype: "v2"
  });
  const [predicted, setPredictedData] = useState("");
  const [predictedId, setPredictedDataId] = useState("");
  const [predictedGpt, setPredictedDataGpt] = useState("");
  const [predictedGptHealthCard, setPredictedDataGptHealthCard] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [feedback, setFeedBack] = useState({
    rating: 0,
    ratingReason: "",
    confidenceLevel: "",
    suggestedNpk: "",
    AgroZone: "",
    Season: ""
  });
  const [indicatorWidth, setIndicatorWidth] = useState(0);

  const [tabIndex, setTabIndex] = useState(0);
  const tabRefs = useRef([]);
  useEffect(() => {
    if (tabRefs.current[tabIndex]) {
      setIndicatorWidth(tabRefs.current[tabIndex].offsetWidth); // Set indicator width based on selected tab
    }
  }, [tabIndex]);

  // Ref for each tab
  const handleTabRef = index => el => {
    tabRefs.current[index] = el;
  };
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState({
    api1: false,
    api2: false
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [upload, setUpload] = useState(false);


  const handleFileUploadHealthCard = async event => {
   setUpload(false)

    const file = event.target.files[0]; // Ensure only a single file is processed
    if (!file) return;
    setFileName(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = e => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }

    setOpenModal(true)


  };

  const handleUploadImage = () => {
     setUpload(true)
     setOpenModal(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
        );
        if (response.status == 200) {
          setVal(data => ({
            ...data,
            nitrogen: response.data.data[0].nitrogen,
            phosphorus: response.data.data[0].phosphorus,
            potassium: response.data.data[0].potassium,
            temperature: response.data.data[0].temperature,
            humidity: response.data.data[0].humidity
          }));
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

    // Optional: Polling every 10 seconds
    // const interval = setInterval(fetchData, 10000);

    // return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const [loadingApi1, setLoadingApi1] = useState(false);
  const [loadingApi2, setLoadingApi2] = useState(false);
  const [loadingApi3, setLoadingApi3] = useState(false);
  const [fileName, setFileName] = useState("");


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const translations = {
    en: {
      manual: "Manual",
      soilCard: "Soil Health Card",
      heading: "Fertilizer Recommendation",
      upload: "Upload Soil Health Card",
      soilType: "Soil type",
      cropType: "Crop type",
      cropTypes: {
        Barley: "Barley",
        Cotton: "Cotton",
        "Ground Nuts": "Ground Nuts",
        Maize: "Maize",
        Millets: "Millets",
        "Oil seeds": "Oil seeds",
        Paddy: "Paddy",
        Pulses: "Pulses",
        Sugarcane: "Sugarcane",
        Tobacco: "Tobacco",
        Wheat: "Wheat",
        coffee: "Coffee",
        kidneybeans: "Kidney Beans",
        orange: "Orange",
        pomegranate: "Pomegranate",
        rice: "Rice",
        watermelon: "Watermelon"
      },
      Temperature: "Temperature",
      uploadOnly: "Upload",
      prediction: "Prediction",
      Humidity: "Humidity",
      Moisture: "Moisture",
      Nitrogen: "Nitrogen",
      Phosphorus: "Phosphorus",
      Potassium: "Potassium",
      predict: "Predict",
      hindi: "Hindi",
      english: "English",
      selectFile: "Select File",
      Black: "Black",
      Clayey: "Clayey",
      Loamy: "Loamy",
      Red: "Red",
      Sandy: "Sandy"
    },
    hi: {
      manual: "मैनुअल",
      soilCard: "मृदा स्वास्थ्य कार्ड",
      heading: "उर्वरक अनुशंसा",
      upload: "मृदा स्वास्थ्य कार्ड अपलोड करें",
      soilType: "मिट्टी का प्रकार",
      cropType: "फसल का प्रकार",
      uploadOnly: "अपलोड करें",
      prediction: "पूर्वानुमान",
      cropTypes: {
        Barley: "जौ",
        Cotton: "कपास",
        "Ground Nuts": "मूंगफली",
        Maize: "मक्का",
        Millets: "बाजरा",
        "Oil seeds": "तेल बीज",
        Paddy: "धान",
        Pulses: "दालें",
        Sugarcane: "गन्ना",
        Tobacco: "तंबाकू",
        Wheat: "गेहूं",
        coffee: "कॉफ़ी",
        kidneybeans: "राजमा",
        orange: "संतरा",
        pomegranate: "अनार",
        rice: "चावल",
        watermelon: "तरबूज"
      },
      Temperature: "तापमान",
      Humidity: "नमी",
      Moisture: "माटी में नमी",
      Nitrogen: "नाइट्रोजन",
      Phosphorus: "फॉस्फोरस",
      Potassium: "पोटैशियम",
      predict: "भविष्यवाणी करें",
      hindi: "हिंदी",
      english: "अंग्रेज़ी",
      selectFile: "फ़ाइल चुनें",
      Black: "काली मिट्टी",
      Clayey: "चिकनी मिट्टी",
      Loamy: "दोमट मिट्टी",
      Red: "लाल मिट्टी",
      Sandy: "बलुई मिट्टी"
    }
  };
  const handlePrediction = async () => {
    try {
      setLoadingApi1(true);
      setLoadingApi2(true);
      // First API Call: Fertilizer Recommendation
      const api1Promise = axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/id`,
          {
            temperature: val.temperature,
            humidity: val.humidity,
            nitrogen: val.nitrogen,
            potassium: val.potassium,
            phosphorous: val.phosphorus,
            croptype: val.croptype,
            soiltype: val.soiltype,
            moisture: val.moisture,
            modeltype: val.modeltype
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          if (response.data.status === "success") {
            setPredictedDataId(response.data.id);
            setPredictedData(response.data.data); // UI updates immediately
          }
        })
        .catch(error => {
          console.error(
            "First API failed:",
            error.response && error.response.data
              ? error.response.data
              : error.message
          );
        })
        .finally(() => setLoadingApi1(false));

      // Second API Call: GPT-based Recommendation
      const api2Promise = axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/gpt`,
          {
            temperature: val.temperature,
            humidity: val.humidity,
            nitrogen: val.nitrogen,
            potassium: val.potassium,
            phosphorus: val.phosphorus,
            crop_type: val.croptype,
            soil_type: val.soiltype,
            soil_moisture: val.moisture,
            language: language == "en" ? "english": "hindi"
          }
        )
        .then(response => {
          setPredictedDataGpt(response.data.response);
          console.log("Second API Data:", response.data.response);
        })
        .catch(error => {
          console.error(
            "Second API failed:",
            error.response && error.response.data
              ? error.response.data
              : error.message
          );
        })
        .finally(() => setLoadingApi2(false));

      // Run both APIs in parallel without blocking UI updates
      await Promise.allSettled([api1Promise, api2Promise]);
    } catch (error) {
      console.error("Unexpected error in API calls:", error);
    }
  };


  const handleChange = e => {
    setVal({ ...val, [e.target.name]: e.target.value });
  };


  const handlePredictHealthCard = async () => {
   if (!fileName) return;
 
   const formData = new FormData();
   formData.append("file", fileName);
   formData.append("language", language === "en" ? "english" : "hindi");
   formData.append("crop_type", val.croptype);
   formData.append("soil_type", val.soiltype);
 
   try {
     setLoadingApi3(true);
 
     const response = await axios.post(
       `${process.env.REACT_APP_BASE_URL}/api/v1/fert/prediction/shc`,
       formData
     );
 
     if (response.data.success === true) {
       setPredictedDataGptHealthCard(response.data.data.recommendation);
     } else {
       console.error("API responded with an error:", response.data);
     }
   } catch (error) {
     console.error(
       "API call failed:");
   } finally {
     setLoadingApi3(false);
   }
 };
 

  const [language, setLanguage] = useState("en");
  const t = translations[language];
  return (
    <>
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "1.5rem" }}>
          <div style={{ textAlign: "right", fontSize: "14px" }}>
            <span
              onClick={() => setLanguage("hi")}
              style={{
                color: language == "hi" ? "#007bff" : "#333",
                marginRight: "10px",
                cursor: "pointer"
              }}
            >
              {t.hindi}
            </span>
            <span
              onClick={() => setLanguage("en")}
              style={{
                color: language == "en" ? "#007bff" : "#333",
                cursor: "pointer"
              }}
            >
              {t.english}
            </span>
          </div>
        </Grid>
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          style={{ marginTop: "1.75rem" }}
          sx={{
            color: "#009951",
            fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
            fontFamily: "Inter, sans-serif",
            fontSize: "1.25rem",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "1.125rem",
            "& .MuiTabs-indicator": {
              backgroundColor: "#009951", // Line color under the selected tab
              height: "2px", // Adjust the height of the indicator
              width: `${indicatorWidth}px`, // Adjust width based on selected tab
              transition: "width 0.3s ease", // Smooth transition for width change
              top: "calc(100% - 8px)"
            }
          }}
        >
          <Tab
            label={t.soilCard}
            ref={handleTabRef(1)}
            sx={{
              color: "#009951",
              fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
              fontFamily: "Inter, sans-serif",
              fontSize: "1.25rem",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "1.125rem",
              textTransform: "none", // Prevent text from being capitalized
              paddingBottom: "0px", // Decrease the bottom padding to reduce gap
              minHeight: "auto", // Adjust the min height to prevent unnecessary space
              "&.Mui-selected": {
                color: "#009951" // Selected tab color
              }
            }}
          />
          <Tab
            label={t.manual}
            ref={handleTabRef(0)}
            sx={{
              color: "#009951",
              fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
              fontFamily: "Inter, sans-serif",
              fontSize: "1.25rem",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "1.825rem",
              textTransform: "none", // Prevent text from being capitalized
              paddingBottom: "0px", // Decrease the bottom padding to reduce gap
              minHeight: "auto", // Adjust the min height to prevent unnecessary space
              "&.Mui-selected": {
                color: "#009951" // Selected tab color
              }
            }}
          />
        </Tabs>

        {tabIndex === 1 && (
          <>
            {" "}
            <Grid container>
              <Grid item xs={12}>
                <Grid
                  item
                  style={{ marginTop: "3rem", marginBottom: "2.25rem" }}
                >
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "1.5rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem"
                    }}
                  >
                    {t.heading}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  borderRadius: "0.75rem",
                  marginBottom: "1.75rem",
                  marginRight: "1rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Temperature} ( °C )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: -10,
                          label: ""
                        },
                        {
                          value: val.temperature,
                          label: `${val.temperature}` // Current value label
                        },
                        {
                          value: 50,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.temperature}
                      name="temperature"
                      valueLabelDisplay="off"
                      min={-10}
                      max={50}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-10px)" // Customize max label position
                        },
                        "& .MuiSlider-markLabel[data-index='2']": {
                          transform: "translateY(6px) translateX(-15px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  marginBottom: "1.75rem",
                  marginRight: "1rem",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Humidity} ( %RH )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: 0,
                          label: ""
                        },
                        {
                          value: val.humidity,
                          label: `${val.humidity}` // Current value label
                        },
                        {
                          value: 100,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.humidity}
                      name="humidity"
                      valueLabelDisplay="off"
                      min={0}
                      max={100}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-15px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  marginBottom: "1.75rem",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Moisture}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: 0,
                          label: ""
                        },
                        {
                          value: val.moisture,
                          label: `${val.moisture}` // Current value label
                        },
                        {
                          value: 100,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.moisture}
                      name="moisture"
                      valueLabelDisplay="off"
                      min={0}
                      max={100}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-15px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  borderRadius: "0.75rem",
                  marginRight: "1rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Nitrogen} ( mg/kg )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: 0,
                          label: ""
                        },
                        {
                          value: val.nitrogen,
                          label: `${val.nitrogen}` // Current value label
                        },
                        {
                          value: 200,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.nitrogen}
                      name="nitrogen"
                      valueLabelDisplay="off"
                      min={0}
                      max={200}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-7px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  borderRadius: "0.75rem",
                  marginRight: "1rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Potassium} ( mg/kg )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: 0,
                          label: ""
                        },
                        {
                          value: val.potassium,
                          label: `${val.potassium}` // Current value label
                        },
                        {
                          value: 200,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.potassium}
                      name="potassium"
                      valueLabelDisplay="off"
                      min={0}
                      max={200}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-7px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3.87}
                style={{
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(245, 138, 32, 0.60)",
                  background: "#FFF",
                  padding: "1rem",
                  boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
                    <Typography
                      variant="h8"
                      style={{
                        color: "#181818",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal"
                      }}
                    >
                      {t.Phosphorus} ( mg/kg )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Slider
                      marks={[
                        {
                          value: 0,
                          label: ""
                        },
                        {
                          value: val.phosphorus,
                          label: `${val.phosphorus}` // Current value label
                        },
                        {
                          value: 200,
                          label: ""
                        }
                      ]}
                      step={1}
                      value={val.phosphorus}
                      valueLabelDisplay="off"
                      name="phosphorus"
                      min={0}
                      max={200}
                      onChange={e => handleChange(e)}
                      sx={{
                        "& .MuiSlider-thumb": {
                          height: "1.5rem", // Thumb height
                          width: "1.5rem", // Thumb width
                          backgroundImage: "url(/thumb.svg)", // Custom image URL
                          backgroundPosition: "center", // Center the image in the thumb
                          "&:hover, &.Mui-focusVisible": {
                            boxShadow: "none" // Remove the glow effect on hover/focus
                          }
                        },
                        "& .MuiSlider-rail": {
                          height: "1.5rem", // Rail height
                          backgroundColor: "grey", // Non-slided portion color (rail)
                          borderRadius: "0.75rem" // Rounded rail
                        },
                        "& .MuiSlider-track": {
                          height: "1.5rem", // Track height
                          borderRadius: "0.75rem", // Rounded track
                          backgroundColor: "#0E2748" // Active portion color (track)
                        },
                        "& .MuiSlider-markLabel[data-index='0']": {
                          transform: "translateY(6px) translateX(0px)" // Customize min label position
                        },
                        "& .MuiSlider-markLabel[data-index='1']": {
                          transform: "translateY(6px) translateX(-7px)" // Customize max label position
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: "2rem" }}>
              <Grid item xs={4}>
                <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal"
                    }}
                  >
                    {t.soilType}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={val.soiltype}
                    name="soiltype"
                    style={{ width: "20rem", height: "4.5rem" }}
                    onChange={e => handleChange(e)}
                  >
                    <MenuItem value="Black">{t.Black}</MenuItem>
                    <MenuItem value="Clayey">{t.Clayey}</MenuItem>
                    <MenuItem value="Loamy">{t.Loamy}</MenuItem>
                    <MenuItem value="Red">{t.Red}</MenuItem>
                    <MenuItem value="Sandy">{t.Sandy}</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal"
                    }}
                  >
                    {t.cropType}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={val.croptype}
                    name="croptype"
                    style={{ width: "20rem", height: "4.5rem" }}
                    onChange={e => handleChange(e)}
                  >
                    <MenuItem value="Barley">{t.cropTypes["Barley"]}</MenuItem>
                    <MenuItem value="Cotton">{t.cropTypes["Cotton"]}</MenuItem>
                    <MenuItem value="Ground Nuts">
                      {t.cropTypes["Ground Nuts"]}
                    </MenuItem>
                    <MenuItem value="Maize">{t.cropTypes["Maize"]}</MenuItem>
                    <MenuItem value="Millets">
                      {t.cropTypes["Millets"]}
                    </MenuItem>
                    <MenuItem value="Oil seeds">
                      {t.cropTypes["Oil seeds"]}
                    </MenuItem>
                    <MenuItem value="Paddy">{t.cropTypes["Paddy"]}</MenuItem>
                    <MenuItem value="Pulses">{t.cropTypes["Pulses"]}</MenuItem>
                    <MenuItem value="Sugarcane">
                      {t.cropTypes["Sugarcane"]}
                    </MenuItem>
                    <MenuItem value="Tobacco">
                      {t.cropTypes["Tobacco"]}
                    </MenuItem>
                    <MenuItem value="Wheat">{t.cropTypes["Wheat"]}</MenuItem>
                    <MenuItem value="coffee">{t.cropTypes["coffee"]}</MenuItem>
                    <MenuItem value="kidneybeans">
                      {t.cropTypes["kidneybeans"]}
                    </MenuItem>
                    <MenuItem value="orange">{t.cropTypes["orange"]}</MenuItem>
                    <MenuItem value="pomegranate">
                      {t.cropTypes["pomegranate"]}
                    </MenuItem>
                    <MenuItem value="rice">{t.cropTypes["rice"]}</MenuItem>
                    <MenuItem value="watermelon">
                      {t.cropTypes["watermelon"]}
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
              {/* <Grid item xs={4}>
              <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
                <Typography
                  style={{
                    color: "rgba(0, 0, 0, 0.80)",
                    fontSize: "1.25rem",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal"
                  }}
                >
                  Model Type
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={val.modeltype}
                  name="modeltype"
                  style={{ width: "20rem", height: "4.5rem" }}
                  onChange={e => handleChange(e)}
                >
                  <MenuItem value="v2">V1</MenuItem>
                </Select>
              </Grid>
            </Grid> */}
              <Grid item xs={12} style={{ marginTop: "2.13rem" }}>
                <Button
                  variant="contained"
                  onClick={handlePrediction}
                  style={{
                    display: "flex",
                    width: "8.75rem",
                    padding: "1rem 1.5rem",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.25rem",
                    borderRadius: "0.5rem",
                    background: "#006BE0"
                  }}
                >
                  {t.predict}
                </Button>
              </Grid>

              {loadingApi1 ? (
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "3.5rem"
                  }}
                >
                  <CircularProgress sx={{ color: "#0E2748" }} size={26} />
                </Grid>
              ) : (
                <>
                  {predicted && (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{
                          marginTop: "3.5rem",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center"
                        }}
                      >
                        <Typography
                          style={{
                            color: "rgba(0, 0, 0, 0.80)",
                            fontSize: "1.5rem",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal"
                          }}
                        >
                          {t.prediction}:
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          marginTop: "0.5rem",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center"
                        }}
                      >
                        <Typography
                          style={{
                            color: "#FFFFFF",
                            fontFamily: "Inter",
                            fontSize: "1.5rem",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal",
                            padding: "0.75rem 1.5rem",
                            borderRadius: "0.75rem",
                            border: "4px solid #F58A20",
                            background: "#0E2748"
                          }}
                        >
                          N-P-K : {predicted}
                        </Typography>
                      </Grid>
                    </>
                  )}

                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "3.5rem",
                      marginBottom: "1.5rem"
                    }}
                  >
                    {t.heading}
                  </Typography>

                  {loadingApi2 ? (
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "3.5rem"
                      }}
                    >
                      <CircularProgress sx={{ color: "#0E2748" }} size={26} />
                    </Grid>
                  ) : (
                    predictedGpt && (
                      <div
                        style={{
                          padding: "1rem",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                        }}
                      >
                        {/* <Typography
                          variant="body1"
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.5",
                            color: "#333",
                            whiteSpace: "pre-line"
                          }}
                        >
                          {predictedGpt.replaceAll("###", "\n")}
                        </Typography> */}

                        <section style={{
                            fontSize: "1rem",
                            lineHeight: "1.5",
                            color: "#333",
                            whiteSpace: "pre-line"
                          }}><ReactMarkdown>{predictedGpt}</ReactMarkdown></section>
                      </div>
                    )
                  )}
                </>
              )}
              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity={severity}>
                  {message}
                </Alert>
              </Snackbar>
            </Grid>
          </>
        )}
        {tabIndex === 0 && (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Grid
                  item
                  style={{ marginTop: "3rem", marginBottom: "2.25rem" }}
                >
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "1.5rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem"
                    }}
                  >
                    {t.heading}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid item style={{ marginBottom: "0.62rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem"
                    }}
                  >
                    {t.upload}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} >
                <label htmlFor="upload-cv">
                  <input
                    type="file"
                    id="upload-cv"
                    style={{ display: "none" }}
                    onChange={handleFileUploadHealthCard}
                  />
                  <Button
                    component="span"
                    variant="contained"
                    startIcon={<UploadFile />}
                    sx={{
                      display: "flex",
                      padding: "0.75rem 1.5rem",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem",
                      borderRadius: "0.5rem",
                      background: "#2A2A2A",
                      whiteSpace: "nowrap", // fixed from "none" to "nowrap"
                      color: "#FFF",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter",
                      fontSize: "0.875rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem",
                      cursor: "pointer",
                      textTransform: "none"
                    }}
                  >
                    {!loading["api1"] ? (
                      t.selectFile
                    ) : (
                      <CircularProgress sx={{ color: "#fff" }} size={26} />
                    )}
                  </Button>
                </label>
              </Grid>
              <Grid item xs={12} style={{ marginBottom: "2.25rem" }}>
              <Typography
        variant="body2"
        sx={{ marginTop: "0.5rem", fontWeight: 500 }}
      >
        {fileName.name}
      </Typography>
              </Grid>
              <Grid item>
                <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal"
                    }}
                  >
                    {t.soilType}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={val.soiltype}
                    name="soiltype"
                    style={{ minWidth: "31.25rem", height: "4.5rem" }}
                    onChange={e => handleChange(e)}
                  >
                    <MenuItem value="Black">{t.Black}</MenuItem>
                    <MenuItem value="Clayey">{t.Clayey}</MenuItem>
                    <MenuItem value="Loamy">{t.Loamy}</MenuItem>
                    <MenuItem value="Red">{t.Red}</MenuItem>
                    <MenuItem value="Sandy">{t.Sandy}</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid item style={{ marginLeft: "1.75rem" }}>
                <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.80)",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal"
                    }}
                  >
                    {t.cropType}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={val.croptype}
                    name="croptype"
                    style={{ width: "31.25rem", height: "4.5rem" }}
                    onChange={e => handleChange(e)}
                  >
                    <MenuItem value="Barley">{t.cropTypes["Barley"]}</MenuItem>
                    <MenuItem value="Cotton">{t.cropTypes["Cotton"]}</MenuItem>
                    <MenuItem value="Ground Nuts">
                      {t.cropTypes["Ground Nuts"]}
                    </MenuItem>
                    <MenuItem value="Maize">{t.cropTypes["Maize"]}</MenuItem>
                    <MenuItem value="Millets">
                      {t.cropTypes["Millets"]}
                    </MenuItem>
                    <MenuItem value="Oil seeds">
                      {t.cropTypes["Oil seeds"]}
                    </MenuItem>
                    <MenuItem value="Paddy">{t.cropTypes["Paddy"]}</MenuItem>
                    <MenuItem value="Pulses">{t.cropTypes["Pulses"]}</MenuItem>
                    <MenuItem value="Sugarcane">
                      {t.cropTypes["Sugarcane"]}
                    </MenuItem>
                    <MenuItem value="Tobacco">
                      {t.cropTypes["Tobacco"]}
                    </MenuItem>
                    <MenuItem value="Wheat">{t.cropTypes["Wheat"]}</MenuItem>
                    <MenuItem value="coffee">{t.cropTypes["coffee"]}</MenuItem>
                    <MenuItem value="kidneybeans">
                      {t.cropTypes["kidneybeans"]}
                    </MenuItem>
                    <MenuItem value="orange">{t.cropTypes["orange"]}</MenuItem>
                    <MenuItem value="pomegranate">
                      {t.cropTypes["pomegranate"]}
                    </MenuItem>
                    <MenuItem value="rice">{t.cropTypes["rice"]}</MenuItem>
                    <MenuItem value="watermelon">
                      {t.cropTypes["watermelon"]}
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: "2.13rem" }}>
                <Button
                  variant="contained"
                  onClick={handlePredictHealthCard}
                  style={{
                    display: "flex",
                    width: "8.75rem",
                    padding: "1rem 1.5rem",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.25rem",
                    borderRadius: "0.5rem",
                    background: "#006BE0"
                  }}
                >
                  {t.predict}
                </Button>
              </Grid>

              {loadingApi3 ? (
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "3.5rem"
                      }}
                    >
                      <CircularProgress sx={{ color: "#0E2748" }} size={26} />
                    </Grid>
                  ) : (
                    predictedGptHealthCard && (
                      <div
                        style={{
                          padding: "1rem",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                        }}
                      >
                        {/* <Typography
                          variant="body1"
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.5",
                            color: "#333",
                            whiteSpace: "pre-line",
                            fontFamily: language === "en" ?  "sans-serif" :  "'Noto Sans Devanagari', sans-serif"
                          }}
                        >
                          {predictedGptHealthCard.replaceAll("###", "\n")}
                        </Typography> */}
                        <section style={{
                            fontSize: "1rem",
                            lineHeight: "1.5",
                            color: "#333",
                            whiteSpace: "pre-line",
                            fontFamily: language === "en" ?  "sans-serif" :  "'Noto Sans Devanagari', sans-serif"
                          }}><ReactMarkdown>{predictedGptHealthCard}</ReactMarkdown></section>
                      </div>
                    )
                  )}
            </Grid>
          </>
        )}

        <ReusableModal
        width="60vw"
        height="90%"
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <Box>
              <Grid container spacing={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                         <Grid item style={{ marginTop: "0.5rem" }}>
                           {imagePreview && (
                             <img
                               src={imagePreview}
                               alt="Selected"
                               style={{
                                 width: "90%",
                                 height: "100%",
                                 flexShrink: 0,
                                 borderRadius: "1.25rem",
                                 backgroundPosition: "cover"
                               }}
                             />
                           )}
                         </Grid>
                         <Grid item xs={12} style={{ marginBottom: "2.25rem", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                
                  <Button
                    component="span"
                    variant="contained"
                    onClick={handleUploadImage}
                    startIcon={<UploadFile />}
                    sx={{
                      display: "flex",
                      padding: "0.75rem 1.5rem",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem",
                      borderRadius: "0.5rem",
                      background: "#2A2A2A",
                      whiteSpace: "nowrap", // fixed from "none" to "nowrap"
                      color: "#FFF",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter",
                      fontSize: "0.875rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem",
                      cursor: "pointer",
                      textTransform: "none"
                    }}
                  >
                    {!loading["api2"] ? (
                      t.uploadOnly
                    ) : (
                      <CircularProgress sx={{ color: "#fff" }} size={26} />
                    )}
                  </Button>
              </Grid>
              </Grid>
          </Box>
        </ReusableModal>
      </Grid>
    </>
  );
};

export default UserView;
